var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ServicePageLayout',{attrs:{"title":"Report","subtitle":"รายงาน","icon":"mdi-chart-box-outline","breadcrumb":"Reports"}},[_c('v-card',{staticClass:"service-content-panel",attrs:{"flat":""}},[_c('v-card-text',[_c('Table')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }